// Read-only-Felder, die per Query in attendees[].bookings[] mitgeladen werden,
// aber vom Input-Typ BookerAttendeeBookingInput NICHT akzeptiert werden.
//
// Die EUA schickt den geladenen Booker (inkl. attendees + deren bookings) als
// Mutations-Input zurueck (createBooker / updateBooker / updateBookerAccountEndUserApp).
// Seit dem Storno-Filter-Fix (booking-eligibility) wird `canceled` in der
// bookings-Selektion mitgeladen; im Mutations-Input loest es sonst
// 400 / BAD_USER_INPUT aus ("Field 'canceled' is not defined by type
// BookerAttendeeBookingInput") und blockiert das Anlegen/Bearbeiten von Teilnehmern.
export const READONLY_BOOKING_INPUT_FIELDS = ["canceled"]

/**
 * Entfernt read-only-Felder ausschliesslich aus `bookings[]`-Elementen der
 * uebergebenen (bereits tief kopierten) Mutations-Variablen. Mutiert das Objekt
 * in-place. Der Scope auf `bookings[]` stellt sicher, dass legitime
 * Storno-Mutationen mit eigenem `canceled`-Argument unberuehrt bleiben.
 */
export const stripReadonlyBookingFields = (value: any): void => {
    if (Array.isArray(value)) {
        value.forEach(stripReadonlyBookingFields)
        return
    }
    if (value && typeof value === "object") {
        if (Array.isArray(value.bookings)) {
            value.bookings.forEach((booking: any) => {
                if (booking && typeof booking === "object") {
                    READONLY_BOOKING_INPUT_FIELDS.forEach((field) => delete booking[field])
                }
            })
        }
        Object.keys(value).forEach((key) => stripReadonlyBookingFields(value[key]))
    }
}
